import React, {useContext, useEffect, useMemo, useRef, useState} from 'react';
import {PlayerContext} from "../../../../shared/contexts/playerContext";
import {Button, Space, Tag} from "antd";
import {Datatable} from "../../../../shared/components/datatable/Datatable";

const MISSION_DIFFICULTY = {
    BEGINNER: 1,   // 초급
    INTERMEDIATE: 2, // 중급
    ADVANCED: 3    // 상급
};

const MISSION_DIFFICULTY_CATEGORY = [
    '없음',
    '초보',
    '중급',
    '상급'
]

const MISSION_STATUS_TEXT = [
    {
        name:'미개방',
        color: 'gray'
    },
    {
        name:'진행중',
        color: 'blue'
    },
    {
        name:'완료',
        color: 'green'
    },
    {
        name:'보상 받음',
        color: 'gold'
    }
]

const inItGuideMissionList = (guideMissions) => {
    if (!guideMissions) {
        return [];
    }

    let {backupData, ...currentGuideMission} = guideMissions;
    if(!backupData) backupData = [];
    return [currentGuideMission, ...backupData];
}

const GuideMission = () => {
    const {playerData} = useContext(PlayerContext);
    const [guideMissions, setGuideMissions] = useState([]);
    const [missionData, setMissionData] = useState([]);
    const [missionType, setMissionType] = useState(MISSION_DIFFICULTY.BEGINNER);

    useEffect(() => {
        setGuideMissions(inItGuideMissionList(playerData.playerInfo.subContentData?.ContentGuideData));
    }, [playerData]);

    useEffect(() => {
        const data = guideMissions.find(e => e.curDifficulty === missionType || e.difficulty === missionType)?.missionData || {};
        setMissionData(Object.values(data));
    }, [missionType]);

    const refreshRef = useRef(null);

    const columns = useMemo(() => [
        {
            title: '가이드 미션 ID',
            dataIndex: 'id',
        },
        {
            title: '번호',
            render: (_, {id}) => id % 100,
        },
        {
            title: '진행 상태',
            render: (_, {isOpened, state}) => {
                if (isOpened) {
                    return <Tag color={MISSION_STATUS_TEXT[state].color}>{MISSION_STATUS_TEXT[state].name}</Tag>;
                } else {
                    return <Tag color={MISSION_STATUS_TEXT[0].color}>{MISSION_STATUS_TEXT[0].name}</Tag>;
                }
            }
        },
        {
            title: '깜짝 타임 어택',
            render: (_, {isTimeAttackExpire, timeAttackExpireTime, state}) => {
                if (isTimeAttackExpire) {
                    return <Tag color="red">실패</Tag>;
                } else if (!isTimeAttackExpire && timeAttackExpireTime && state >= 3) {
                    return <Tag color="green">성공</Tag>;
                } else {
                    return <Tag color="gray">-</Tag>;
                }
            }
        }
    ],[]);
    return (
        <div>
            <Space style={{ display: 'flex', gap: 8, margin: 16 }}>
                {
                    MISSION_DIFFICULTY_CATEGORY.slice(1).map((category, index) => (
                        <Button
                            key={index + 1}
                            onClick={() => setMissionType(index + 1)}
                            type={missionType === index + 1 ? 'primary' : 'default'}
                        >
                            {category}
                        </Button>
                    ))
                }
            </Space>
            <Datatable columns={columns} refresh={refreshRef} rows={missionData}/>
        </div>
    );
};

export default GuideMission;